/* eslint-disable */
import Swiper, { EffectFade, Navigation, Pagination, Parallax, Thumbs } from "swiper";
import AOS from "aos";
// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Parallax, EffectFade, Thumbs]);





jQuery(document).ready(() => {
    // init Swiper:
    var galleryThumbs = new Swiper('.gallery-thumbs', {
        spaceBetween: 10,
        slidesPerView: 3,
        loop: false,
        freeMode: true,
        loopedSlides: 3, //looped slides should be the same
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
    });
    var galleryTop = new Swiper('.gallery-top', {
        spaceBetween: 10,
        loop: true,
        loopedSlides: 5, //looped slides should be the same
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        thumbs: {
            swiper: galleryThumbs,
        },
    });

    //Gallery Popup
	const galleryEl = $('.gallery-item > a');
	galleryEl.addClass('term-button');


    const popup = $('.gallery-overlay');
    const gallery_link = localStorage.getItem('gallery-warning');

    $('.term-button').on('click', function (e) {
        if (gallery_link !== 'true') {
            e.preventDefault();
            localStorage.setItem('gallery-link', $(this).attr('href'));
            popup.css('display', 'flex')
        }
    });

    $('.popup-buttons__yes').on('click', function () {
        localStorage.setItem('gallery-warning', 'true');
        popup.css('display', 'none');
        window.location.href = localStorage.getItem('gallery-link');
    });

    $('.popup-buttons__no').on('click', function () {
        popup.css('display', 'none');
    });
});

/* eslint-enable */



// WEBPACK FOOTER //
// ./scripts/modules/gallery.js